import { useEffect } from 'react';

import { experiments } from '@/utils/experiment/manifest';
import { useExperimentExposure } from '@/utils/experiment/use-experiment-exposure';

import { UniformEntryPage, UniformEntryPageProps } from './uniform-entry-page.tsx';

export const UniformConfluencePricingEntryPage = (props: UniformEntryPageProps) => {
	const [hasFired, fireExposure] = useExperimentExposure(
		experiments.confluencePricingPageWaeMigration,
	);

	useEffect(() => {
		if (!hasFired) {
			fireExposure();
		}
	}, [hasFired, fireExposure]);

	return <UniformEntryPage {...props} />;
};
